import { MASTER_ROLE, DISTRIBUTOR_ROLE, ADMIN_ROLE, PROFESSIONAL_ROLE } from '@/constants/roles';

export type Role =
  | typeof MASTER_ROLE
  | typeof ADMIN_ROLE
  | typeof DISTRIBUTOR_ROLE
  | typeof PROFESSIONAL_ROLE;

const roleHierarchy: Role[] = [MASTER_ROLE, DISTRIBUTOR_ROLE, ADMIN_ROLE, PROFESSIONAL_ROLE];

export default function getHighestRole(roles: Role[] = []): Role | null {
  if (!roles || !roles.length) return null;

  return (
    roles?.reduce((highest, current) => {
      const highestIndex = roleHierarchy.indexOf(highest);
      const currentIndex = roleHierarchy.indexOf(current);
      return currentIndex < highestIndex ? current : highest;
    }) || null
  );
}
